import React, { useState } from 'react';
import useAppStore from '../../store';
import { formatRelativeTime } from '../../lib/formatters/time';

const STATUS_GLYPHS = {
  delivered: '✓',
  queued: '…',
  failed: '✕'
};

function MessageLogTable() {
  const channelMessages = useAppStore((state) => state.channelMessages);
  const channels = useAppStore((state) => state.channels);
  const [filter, setFilter] = useState('all');

  const visible = channelMessages.filter((message) => (
    filter === 'all' || message.channelType === filter
  ));

  return (
    <div className="message-log">
      <div className="message-log__filters">
        {['all', ...channels.map((channel) => channel.type)].map((type) => (
          <button
            className={filter === type ? 'filter-chip is-active' : 'filter-chip'}
            key={type}
            onClick={() => setFilter(type)}
            type="button"
          >
            {type === 'all' ? 'All' : type}
          </button>
        ))}
      </div>

      <table className="message-log__table">
        <thead>
          <tr>
            <th scope="col">Channel</th>
            <th scope="col">Message</th>
            <th scope="col">Dir</th>
            <th scope="col">Status</th>
            <th scope="col">When</th>
          </tr>
        </thead>
        <tbody>
          {visible.map((message) => (
            <tr key={message.id}>
              <td className="message-log__channel">{message.channelType}</td>
              <td className="message-log__preview">{message.preview}</td>
              <td>{message.direction === 'inbound' ? '← in' : '→ out'}</td>
              <td>
                <span className={`msg-status msg-status--${message.status}`}>
                  {STATUS_GLYPHS[message.status]} {message.status}
                </span>
              </td>
              <td>{formatRelativeTime(message.timestamp)}</td>
            </tr>
          ))}
          {visible.length === 0 && (
            <tr>
              <td colSpan={5}>No messages on this channel yet.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default MessageLogTable;
